import React, {Component} from 'react'

const Impressum = () => {
    return (
        <div id="impressum">
            <h1>Impressum:</h1>
            <h2>Verantwortlich für den Inhalt:</h2>
            <p>Urologische Praxis</p>
            <p>urologische Berufsausübungsgemeinschaft Dr. med. uni. G. Tosev, Dr. med. J. Felgner, Dr. med. C. Geil-Bierschenk, Dr. med. H. Sobek</p>

            <p> Neckarstraße 7</p>
            <p> 68259 Mannheim</p>
            <p> Tel. 0621 - 474353</p>
            <p> Fax. 0621 - 4819107</p>
            <p> eMail:  kontakt@urologie-mannheim.info</p>
            <p> Internet: www.urologie-mannheim.info</p>
 
            <p>Kontak des Datenschutzbeauftragten der Homepage unter datenschutz@urologie-mannheim.info</p>


            <h2>Zuständige Ärztekammer:</h2>
            <p>Landesärztekammer Baden-Württemberg  <a href="www.aerztekammer-bw.de">www.aerztekammer-bw.de</a></p>

             <h2>Berufsordnung:</h2>
            <p> <a href="http://www.aerztekammer-bw.de/10aerzte/40merkblaetter/20recht/05kammerrecht/bo.pdf">http://www.aerztekammer-bw.de/10aerzte/40merkblaetter/20recht/05kammerrecht/bo.pdf</a></p>

            <h2>Gesetzliche Berufsbezeichnung und der Staat, in dem sie erworben wurde:</h2>
            <p>Fachärzte für Urologie, Deutschland</p>

            <h2>Haftungsausschluss:</h2>
            <p>Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.</p>


            <h2>Copyright:</h2>
            <p>Sowohl die Inhalte als auch die Gestaltung dieser Website sind urheberrechtlich geschützt. Jegliche Vervielfältigung und Verbreitung bedürfen der vorherigen schriftlichen Zustimmung der im Webimpressum genannten verantwortlichen Personen.</p>
 
            <h2>Haftung für Inhalte:</h2>

            <p>Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
Als Diensteanbieter sind wir gemäß § 6 Abs.1 MDStV und § 8 Abs.1 TDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Diensteanbieter sind jedoch nicht verpflichtet, die von Ihnen übermittelten oder gespeicherten fremden Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei bekannt werden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
Haftung für Links
Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei bekannt werden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
 
            <h2>Urheberrecht:</h2>

            <p>Der Betreiber der Seiten ist bemüht, stets die Urheberrechte anderer zu beachten bzw. auf selbst erstellte sowie lizenzfreie Werke zurückzugreifen.
Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
Beiträge Dritter sind als solche gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p>
 

            <p>Quellverweis: eRecht24 Disclaimer, Google Analytics Datenschutzerklärung,</p>
 
            <p>Quelle: e-recht24.de Rechtsberatung von RA Sören Siebert</p>
 

        </div>
    )
}

export default Impressum



// WEBPACK FOOTER //
// ./src/Components/Impressum.js